import { ChangeEvent, ReactElement } from 'react';
import { CgSearch } from 'react-icons/cg';
import { Input } from '@chakra-ui/react';

import { InputGroup } from '~/core/shared/lib/chakraUi/components';

type SearchEvent = {
  handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
};

export const SearchInput = ({
  handleInputChange,
  placeholder = 'Search',
}: SearchEvent): ReactElement => (
  <InputGroup startElement={<CgSearch color="gray" />}>
    <Input
      m={2}
      onChange={(event) => handleInputChange(event)}
      pl={10}
      placeholder={placeholder}
      size="md"
      width="100%"
    />
  </InputGroup>
);
